import { cn } from "@/lib/utils";
import type { CleanerAppLanguage } from "@/hooks/useCleanerAppLanguage";

const OPTIONS: { code: CleanerAppLanguage; label: string }[] = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];

export function CleanerLanguageToggle({
  value,
  disabled,
  size = "md",
  onChange,
}: {
  value: CleanerAppLanguage;
  disabled?: boolean;
  size?: "sm" | "md";
  onChange: (language: CleanerAppLanguage) => void;
}) {
  return (
    <div className={cn("grid grid-cols-2", size === "sm" ? "gap-1.5" : "gap-2")}>
      {OPTIONS.map((opt) => {
        const on = value === opt.code;
        return (
          <button
            key={opt.code}
            type="button"
            disabled={disabled}
            onClick={() => {
              if (!on) onChange(opt.code);
            }}
            className={cn(
              "rounded-xl border-[1.5px] font-bold disabled:opacity-50",
              size === "sm" ? "h-9 px-2 text-[13px]" : "h-12 text-[15px]",
              on
                ? "border-[#24a89a] bg-[#e2eeed] text-[#15776d]"
                : "border-[#e6edf1] bg-white text-[#475569]",
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
